<template>
    <div class="flex justify-between items-center shadow-custom rounded-md bg-white p-4 cursor-pointer">
        <div>
            <p class="text-main-color font-semibold text-xl	">{{ detail?.name }}</p>
            <p class="text-[#409DBA] text-lg font-semibold">{{ detail?.products__count }} {{ $t('page.product') }}</p>
        </div>
        <div>
            <p class="text-white font-medium text-xs py-[0.25rem] px-3 rounded rounded-tl-none rounded-br-none bg-[#CB3131]">
                {{ detail?.products__count }}</p>
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    props: {
        detail: {
            type: Object,
            required: true
        }
    },
    components: {
        
    },
    data(){
        return {
            loading: false
        }
    },
    methods: {

    },
    computed: {

    },
    created(){

    }
}

</script>